import { morphism, StrictSchema } from 'morphism';

//TODO: TypeScript has some complicated issues here we should fix/improve
export function mapObjectFromSchema<Source, Destination>(schema, object): Destination {
    const objectArrayKeys = Object.keys(schema).filter(key=>key.endsWith('[]'));

    // Clone the schema so that the function remains pure and we don't modify the schema object passed in
    const clonedSchema = { ...schema };
    const objectArrayResults = {};

    // Object arrays are normally handled by functions, but that makes generating schemas hard. Instead we will dynamically
    // search for any schema key ending in []. These keys we will remove before running morphism and we will separately
    // run morphism on each array item using the schema contained reggressively.
    if (objectArrayKeys.length > 0) {
        objectArrayKeys.forEach(key => {
            const currentSchema = { ...clonedSchema[key] };
            const currentObjectMapperKey = currentSchema.objectMapperKey;
            delete currentSchema.objectMapperKey;
            const actualKey = key.replace('[]', '');

            if (Array.isArray(object)) {
                objectArrayResults[actualKey] = object.map(item => {
                    const currentArrayToMap = item[currentObjectMapperKey]
                    let mappedData = mapObjectFromSchema(currentSchema, currentArrayToMap) ?? [];
                    return Object.values(mappedData);
                });
            } else {
                const currentArrayToMap = object[currentObjectMapperKey];
                let mappedResults = mapObjectFromSchema(currentSchema, currentArrayToMap) ?? [];
                objectArrayResults[actualKey] = Object.values(mappedResults);
            }
            delete clonedSchema[key];
        });
    }
    const nonObjectArrayResults: {} = morphism(clonedSchema, object);


    if (Array.isArray(object)) {
        Object.keys(objectArrayResults).forEach((key)=>{
            objectArrayResults[key].forEach((item, index)=>{
                nonObjectArrayResults[index][key] = item;
                delete nonObjectArrayResults[index][key+'[]'];
            });
        });
        return nonObjectArrayResults as Destination;
    } else {
        const result: unknown = {
            ...nonObjectArrayResults,
            ...objectArrayResults
        };

        return result as Destination;
    }
}
